<div class="legal-view">
    <div class="legal-section">
        <h3 class="legal-label">Legal</h3>
        <ccdl-divider size="md"></ccdl-divider>
    </div>

    <div class="legal-title-section">
        <h1 class="legal-title">Terms of Use</h1>
        <ccdl-divider size="sm"></ccdl-divider>
    </div>

    <div class="legal-content">
        <div class="last-updated"><em>Last Updated:</em> April 13, 2026</div>

        <div class="content-block">
            <h3 class="content-header">Ownership of Site &amp; Agreement to
                Terms</h3>
            <p class="content-paragraph">These Terms of Use apply to the
                Capvizon website and all
                associated sites linked to Capvizon by its subsidiaries and
                affiliates (collectively,
                the "Site"). The Site is the property of Capvizon and its
                licensors. <strong
                    class="content-strong">By using the Site, you agree to these
                    Terms of Use; if you
                    do not agree, do not use the Site.</strong></p>
            <p class="content-paragraph">Capvizon reserves the right, at its
                sole discretion, to
                change, modify, add, or remove portions of these Terms of Use at
                any time. It is your
                responsibility to check these Terms periodically for changes.
                Your continued use of the
                Site following the posting of changes will mean that you accept
                and agree to the
                changes.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Description of Service</h3>
            <p class="content-paragraph">Capvizon provides a platform for users
                to manually log,
                share, and calculate expenses. We are an <strong
                    class="content-strong">information
                    storage and calculation tool only.</strong> We do not
                facilitate payments, money
                transfers, or financial transactions of any kind.</p>
            <p class="content-paragraph">You may use the Service to create
                expense groups, add and
                categorize expenses, split costs among participants, and view
                balance summaries and
                expense insights. The Service is provided for personal,
                non-commercial use only unless
                otherwise agreed in writing.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Content</h3>
            <p class="content-paragraph">All text, graphics, user interfaces,
                visual interfaces,
                photographs, trademarks, logos, artwork, and computer code
                (collectively, "Content"),
                including but not limited to the design, structure, selection,
                coordination, expression,
                "look and feel," and arrangement of such Content, contained on
                the Site is owned,
                controlled, or licensed by or to Capvizon, and is protected by
                trade dress, copyright,
                patent, and trademark laws, and various other intellectual
                property rights.</p>
            <p class="content-paragraph">No part of the Site and no Content may
                be copied, reproduced,
                republished, uploaded, posted, publicly displayed, encoded,
                translated, transmitted, or
                distributed in any way to any other computer, server, website,
                or other medium for
                publication or distribution or for any commercial enterprise,
                without Capvizon's express
                prior written consent.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Your Use of the Site</h3>
            <p class="content-paragraph">You may not use any automated device,
                program, algorithm, or
                methodology, or any similar or equivalent manual process, to
                access, acquire, copy, or
                monitor any portion of the Site or any Content, or in any way
                reproduce or circumvent
                the navigational structure or presentation of the Site.</p>
            <p class="content-paragraph">You may not attempt to gain
                unauthorized access to any portion
                or feature of the Site, or any other systems or networks
                connected to the Site or to any
                Capvizon server, by hacking, password mining, or any other
                illegitimate means.</p>
            <p class="content-paragraph">You agree not to use any device,
                software, or routine to
                interfere or attempt to interfere with the proper working of the
                Site or any transaction
                being conducted on the Site, or with any other person's use of
                the Site.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">User Responsibilities</h3>
            <p class="content-paragraph"><strong
                    class="sub-header">Accuracy:</strong> You are solely
                responsible for the accuracy of the data you input into
                Capvizon. We do not verify or
                validate expense entries, amounts, or descriptions provided by
                users.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Security:</strong> You are
                responsible for safeguarding your password and account access.
                You must notify us
                immediately of any unauthorized use of your account or any other
                breach of security. You
                may be held liable for losses incurred by Capvizon or any other
                user due to someone else
                using your account as a result of your failing to keep your
                account information secure.
            </p>
            <p class="content-paragraph"><strong class="sub-header">Lawful
                    Use:</strong> You may not
                use the Site or any Content for any purpose that is unlawful or
                prohibited by these
                Terms of Use, or to solicit the performance of any illegal
                activity or other activity
                which infringes the rights of Capvizon or others.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Accounts, Passwords and Security</h3>
            <p class="content-paragraph">Certain features or services offered on
                or through the Site
                may require you to open an account (including setting up a
                Capvizon ID and password).
                You are entirely responsible for maintaining the confidentiality
                of the information you
                hold for your account, including your password, and for any and
                all activity that occurs
                under your account.</p>
            <p class="content-paragraph">You agree to notify Capvizon
                immediately of any unauthorized
                use of your account or password, or any other breach of
                security. Capvizon cannot and
                will not be liable for any loss or damage arising from your
                failure to comply with these
                obligations.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Disclaimers &amp; Limitation of
                Liability</h3>
            <p class="content-paragraph"><strong class="sub-header">"As-Is"
                    Basis:</strong> The
                Service, the Site, and all calculations are provided "as-is" and
                "as-available." Capvizon
                does not guarantee 100% mathematical accuracy for complex custom
                splits. Capvizon
                disclaims all warranties, express or implied, including any
                warranties of accuracy,
                non-infringement, merchantability, and fitness for a particular
                purpose.</p>
            <p class="content-paragraph"><strong class="sub-header">Data
                    Breaches:</strong> To the
                maximum extent permitted by applicable law, Capvizon shall not
                be liable for any
                indirect, incidental, or consequential damages resulting from
                data breaches or
                unauthorized access.</p>
            <p class="content-paragraph"><strong class="sub-header">No Financial
                    Advice:</strong> Our
                "Expense Insights" are for informational purposes only and do
                not constitute
                professional financial advice.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Limitation:</strong> Except where
                prohibited by law, in no event will Capvizon be liable to you
                for any indirect,
                consequential, exemplary, incidental, or punitive damages,
                including lost profits, even
                if Capvizon has been advised of the possibility of such
                damages.</p>
            <p class="content-paragraph">As a startup, Capvizon provides
                calculation tools "as-is." We
                are not responsible for financial discrepancies or data breaches
                beyond our reasonable
                control to the maximum extent permitted by the <strong
                    class="content-strong">Indian
                    Judicial Act.</strong></p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Links to Other Sites</h3>
            <p class="content-paragraph">The Site may contain links to other
                independent third-party
                websites ("Linked Sites"). These Linked Sites are provided
                solely as a convenience to
                our visitors. Such Linked Sites are not under Capvizon's
                control, and Capvizon is not
                responsible for and does not endorse the content of such Linked
                Sites. You will need to
                make your own independent judgment regarding your interaction
                with these Linked Sites.
            </p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Governing Law</h3>
            <p class="content-paragraph">All legal matters and interpretations
                of these Terms shall be
                governed by and construed in accordance with the <strong
                    class="content-strong">Indian
                    Judicial Act</strong> and applicable federal laws of India.
                You agree to the personal
                jurisdiction by and venue in the courts located in India.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Mandatory Dispute Resolution &amp; Notice
                Period</h3>
            <p class="content-paragraph">In the event of any controversy, claim,
                or dispute arising out
                of or relating to these Terms:</p>
            <p class="content-paragraph"><strong class="sub-header">Pre-Action
                    Notice:</strong> You
                agree to first attempt to resolve the issue informally by
                sending a detailed written
                notice to <ccdl-link linkText="Privacy and Terms Team."
                    linkType="default" size="xs" [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link>
            </p>
            <p class="content-paragraph"><strong class="sub-header">Wait
                    Period:</strong> No legal
                proceedings or formal claims may be commenced until <strong
                    class="content-strong">90
                    days</strong> have passed from the date the initial notice
                email was sent, allowing
                both parties an opportunity for amicable resolution.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Jurisdiction:</strong> If a
                resolution is not reached within this 90-day period, the dispute
                shall be subject to the
                exclusive jurisdiction of the courts located in India.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Indemnity</h3>
            <p class="content-paragraph">You agree to indemnify and hold
                Capvizon, its officers,
                directors, employees, agents, subsidiaries, and affiliates,
                harmless from any demands,
                loss, liability, claims, or expenses (including attorneys'
                fees), made against Capvizon
                by any third party due to or arising out of or in connection
                with your use of the Site.
            </p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Miscellaneous</h3>
            <p class="content-paragraph">If any of the provisions of these Terms
                of Use are held by a
                court or other tribunal of competent jurisdiction to be void or
                unenforceable, such
                provisions shall be limited or eliminated to the minimum extent
                necessary and replaced
                with a valid provision that best embodies the intent of these
                Terms, so that these Terms
                shall remain in full force and effect.</p>
            <p class="content-paragraph">These Terms of Use constitute the
                entire agreement between you
                and Capvizon with regard to your use of the Site. Capvizon's
                failure to insist on or
                enforce strict performance of these Terms shall not be construed
                as a waiver by Capvizon
                of any provision or any right it has to enforce these Terms.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Contact Us</h3>
            <p class="content-paragraph">Questions regarding these Terms should
                be sent to:
                <ccdl-link linkText="Privacy and Terms Team."
                    linkType="default" size="xs" [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link>
            </p>
        </div>

        <div class="content-footer">
            <h3 class="content-header">Feedback and Site Updates</h3>
            <p class="footer-text">Any comments or suggestions you share on this
                site are considered non-confidential.</p>
            <p class="footer-text">Capvizon reserves the right to use this
                feedback freely and without any limitations. Additionally, the
                content on this website may be updated or modified at any time
                without prior warning.</p>
        </div>
    </div>
</div>
